<template>
  <div>
    <homepage-header />

    <homepage-benefits />

    <homepage-product-list />

    <homepage-video-list />

    <homepage-article-list />

    <homepage-testimony-list />

    <homepage-footer />

    <seo-text />
  </div>
</template>
<script>
/* istanbul ignore file */
import meta from 'shared/modules/seo/meta';
import SeoText from 'seo-mobile/components/SeoText';
import HomepageHeader from './components/Header';
import HomepageBenefits from './components/Benefits';
import HomepageProductList from './components/ProductList';
import HomepageVideoList from './components/VideoList';
import HomepageArticleList from './components/ArticleList';
import HomepageTestimonyList from './components/TestimonyList';
import HomepageFooter from './components/Footer';

export default {
  name: 'Homepage',
  components: {
    HomepageHeader,
    HomepageBenefits,
    HomepageProductList,
    HomepageVideoList,
    HomepageArticleList,
    HomepageTestimonyList,
    HomepageFooter,
    SeoText,
  },

  mounted() {
    document.title = meta.default.title;
  },
};
</script>
